<div class="sidebar-candidate-activities"><app-loading [isLoading]="isLoading"><app-table [cols]="cols" [rows]="rows"></app-table></app-loading></div>
